export default "__VITE_ASSET___hMzefaH__"